var render = function render(){var _vm=this,_c=_vm._self._c;return _c('badge',{attrs:{"type":_vm.getBadgeType()}},[_vm._v(_vm._s(_vm.$t('TRANSACTIONS_DPA.' + _vm.data.status)))])
}
var staticRenderFns = []

export { render, staticRenderFns }